import { Stack } from '@mui/material';

import { QuickFilterSearchbar } from '@/components/tables/DataTable/components/QuickFilterSearchbar';

export function MemosSearchToolbar() {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      mb={2}
    >
      <QuickFilterSearchbar
        debounceMs={500}
        variant="outlined"
        placeholder="Search memos"
      />
    </Stack>
  );
}
